module.exports = __webpack_public_path__ + "statics/img/wx.3dfaeb62.svg";